// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = ['M1.5 3.5H14.5M4 8H12M6.25 12.5H9.75'];
